module.exports = __webpack_public_path__ + "static/media/cleanvertising-light.ed53c4d5.woff";